'use strict'

import axios from 'axios'
import { CODE, DATA } from '../util/constants'
import { api } from './api'
import config from '../config'

axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.reject(error.response)
})

function onSuccess (response, url) {
  if (url === api.user.MYSELF()) {
    sessionStorage.setItem('username', response.data.email)
  }
  return 200
}

function onError (res) {
  var type = res.data.type
  if (type === 10001 || type === '10001') {
    const data = []
    for (var i in res.data.fields) {
      if (DATA[i]) {
        switch (DATA[i]) {
          case '密码':
            data.push('密码强度低，请避免使用生日、姓名、连续数字或字母等')
            break
          case '邮箱':
            data.push('邮箱不能为临时邮箱')
            break
          case '手机号':
            data.push('检测到异常手机号，黑卡')
            break
          default:
            data.push(DATA[i] + '数据错误')
            break
        }
      }
    }
    return data.join(',')
  } else if (type === 10002 || type === '10002') {
    const fields = []
    res.data.fields.map((value) => {
      if (DATA[value]) {
        fields.push(DATA[value])
      }
    })
    if (fields.join(',') === '邮箱') {
      return fields.join(',') + '已存在，建议直接登录'
    } else if (fields.join(',') === '手机号') {
      return handlePhoneExist(res.data.fields)
    }
    return fields.join(',') + '已存在'
  }
  return CODE[type] || '验证错误，请重新验证'
}

function handlePhoneExist (fields) {
  const email = fields[1]
  const emailTip = email.substring(0, 1) + '***' + email.substring(email.indexOf('@') - 1)
  return `手机号已存在，请用绑定邮箱${emailTip}登陆`
}

export default {
  post (url, data) {
    return axios({
      method: 'POST',
      url: url,
      data: data,
      xsrfCookieName: config.CSRF_ROOT_COOKIE_NAME,
      xsrfHeaderName: config.CSRF_ROOT_HEADER_NAME
    }).then(
      (response) => {
        return onSuccess(response)
      }
    ).catch(
      (res) => {
        console.log('123')
        return onError(res)
      }
    )
  },
  get (url, params) {
    return axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return onSuccess(response, url)
      }
    ).catch(
      (res) => {
        return onError(res)
      }
    )
  },
  patch (url, params) {
    return axios({
      method: 'patch',
      url: url,
      data: params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return onSuccess(response, url)
      }
    ).catch(
      (res) => {
        return onError(res)
      }
    )
  }
}
